import { CacheHandler } from 'reusable/utils/cache'

const userCache = {
   serviceUser: new CacheHandler<string>({ key: 'GapAppServiceUser', cacheLocation: 'localStorage', useRawKey: true }),
   hideCompletedCheckListSteps: new CacheHandler<boolean>({ key: 'GapAppHideCompletedCheckListSteps', cacheLocation: 'localStorage' })
}

export default userCache
